import { Button } from 'foundations-components/transitional/components/Button';
import getAppUrls from 'calling-orchestration-shared-library/constants/appUrls';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const TurnOnTranscriptionButton = () => {
  const {
    callingConfigurationSettingsUrl
  } = getAppUrls();
  const navigateToSettings = useCallback(() => {
    (window.top || window).location.href = callingConfigurationSettingsUrl;
  }, [callingConfigurationSettingsUrl]);
  return /*#__PURE__*/_jsx(Button, {
    use: "primary",
    role: "link",
    block: true,
    onClick: navigateToSettings,
    marginBlockEnd: "600",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "recordingReviewComponents.shared.turnOnTranscriptionButton.label"
    })
  });
};